import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Header, Table, Label, Icon, Input, Pagination, Dropdown } from "react-frontier";
import { useBreadcrumbs } from "../Hooks";
import { PromoterListItem, UserClass, PromoterStatus } from "../SiteClasses";
import { formatUnix, getStatusColor } from "../SiteUtil";
import API from "../API";

const PAGE_SIZE = 20;

var Promoters = ()=>{
	var navigate = useNavigate();
	var { setTitle } = useBreadcrumbs();
	var [loadError, setLoadError] = useState<string>(null);
	var [promoters, setPromoters] = useState<PromoterListItem[]>(null);
	var [total, setTotal] = useState<number>(0);
	var [filter, setFilter] = useState<string>('');
	var [page, setPage] = useState<number>(0);
	var [users, setUsers] = useState<UserClass[]>(null);
	var [userFilter, setUserFilter] = useState<number>(null);
	var [statuses, setStatuses] = useState<PromoterStatus[]>(null);
	var [statusFilter, setStatusFilter] = useState<number>(null);

	useEffect(()=>{
		setTitle('Promotores');
		API.getUsers(200, 0).then(res=>{ if(!res.error) setUsers(res.data || []); }).catch(()=>{});
		API.getStatuses().then(res=>{ if(!res.error) setStatuses(res.data || []); }).catch(()=>{});
	}, []);

	useEffect(()=>{
		var run = ()=>{
			setLoadError(null);
			API.getPromoters({
				search: filter.trim() || undefined,
				user_id: userFilter ?? undefined,
				status_id: statusFilter ?? undefined,
				page,
			}).then(res=>{
				if(res.error) return setLoadError(res.message);
				setPromoters(res.data.promoters);
				setTotal(res.data.total);
			}).catch(()=>{
				setLoadError('Hubo un error al obtener los promotores. (GPM-1)');
			});
		};
		var t = setTimeout(run, 300);
		return ()=>clearTimeout(t);
	}, [filter, userFilter, statusFilter, page]);

	if(loadError) return <Header text='Error' subtext={loadError} />;

	return <div>
		<Table style={{ maxWidth: 900, margin: 'auto', marginTop: 20 }} striped selectable>
			<Table.Head title='Promotores'>
				<Table.Row>
					<Table.Cell colSpan={6} style={{ padding: 8 }}>
						<div style={{ display: 'flex', gap: 8, alignItems: 'flex-end' }}>
							<Input fluid placeholder='Buscar...' value={filter} onChange={v=>{ setFilter(v); setPage(0); }} iconName='search' style={{ margin: 0, flex: 1 }} />
							<Dropdown
								search
								label='Asignado a'
								placeholder='Asignado a'
								value={userFilter!=null ? String(userFilter) : ''}
								items={[{ text: 'Todos', value: '' }, { text: 'Sin asignar', value: '0' }, ...(users || []).map(u=>({ text: `${u.first_name} ${u.last_name}`, value: String(u.user_id) }))]}
								onValueChange={v=>{ setUserFilter(v!=null && v!=='' ? parseInt(v) : null); setPage(0); }}
								style={{ minWidth: 200, margin: 0 }}
							/>
							<Dropdown
								search
								label='Estatus'
								placeholder='Estatus'
								value={statusFilter!=null ? String(statusFilter) : ''}
								items={[{ text: 'Todos', value: '' }, ...(statuses || []).map(s=>({ text: s.status_name, value: String(s.status_id) }))]}
								onValueChange={v=>{ setStatusFilter(v!=null && v!=='' ? parseInt(v) : null); setPage(0); }}
								style={{ minWidth: 200, margin: 0 }}
							/>
						</div>
					</Table.Cell>
				</Table.Row>
				<Table.Row>
					<Table.Cell header collapsing centered>ID</Table.Cell>
					<Table.Cell header centered>Empresa organizadora</Table.Cell>
					<Table.Cell header centered>Asignado a</Table.Cell>
					<Table.Cell header centered>Actividad</Table.Cell>
					<Table.Cell header collapsing centered>Creado</Table.Cell>
					<Table.Cell header collapsing centered>Estatus</Table.Cell>
				</Table.Row>
			</Table.Head>
			<Table.Body>
				{!promoters ? (
					<Table.Row><Table.Cell colSpan={6} centered><Header loading text='Cargando datos' /></Table.Cell></Table.Row>
				) : promoters.length === 0 ? (
					<Table.Row><Table.Cell colSpan={6} centered>No se encontraron registros</Table.Cell></Table.Row>
				) : (
					promoters.map(p=>(
						<Table.Row key={p.promoter_id} selectable onClick={()=>navigate(`/promoters/${p.promoter_id}`)}>
							<Table.Cell collapsing>{p.promoter_id}</Table.Cell>
							<Table.Cell>{p.promoter_name}</Table.Cell>
							<Table.Cell centered>{p.user_assigned_name ? p.user_assigned_name : <Icon name='minus' />}</Table.Cell>
							<Table.Cell>{p.last_activity ? p.last_activity : <Icon name='minus' />}</Table.Cell>
							<Table.Cell collapsing centered>{p.date_created ? formatUnix(p.date_created, 'dd/MM/yyyy') : <Icon name='minus' />}</Table.Cell>
							<Table.Cell collapsing centered>
								{p.status_name ? <Label color={getStatusColor(p.status_id)}>{p.status_name}</Label> : <Icon name='minus' />}
							</Table.Cell>
						</Table.Row>
					))
				)}
			</Table.Body>
		</Table>
		{(total > PAGE_SIZE || page !== 0) && (
			<div style={{ maxWidth: 900, margin: 'auto', marginTop: 10 }}>
				<Pagination page={page} pageCount={Math.ceil(total / PAGE_SIZE)} onPageChange={setPage} />
			</div>
		)}
	</div>
}

export default Promoters;
